import { twMerge } from "tailwind-merge";

interface Props {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  className?: string;
  type?: "button" | "submit" | "reset";
}

const defaultButtonClass =
  "bg-blue-400 hover:bg-blue-500 disabled:opacity-50 text-white py-2 px-4 rounded-md cursor-pointer";
const defaultMiniButtonClass =
  "text-xs bg-blue-400 hover:bg-blue-500 disabled:opacity-50 text-white py-1 px-2 rounded-md cursor-pointer flex flex-row gap-1 items-center";

export const PrimaryButton = ({ children, onClick, disabled, className, type = "button" }: Props) => {
  return (
    <button className={twMerge(defaultButtonClass, className)} type={type} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};

export const MiniPrimaryButton = ({ children, onClick, disabled, className, type = "button" }: Props) => {
  return (
    <button className={twMerge(defaultMiniButtonClass, className)} type={type} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};
